<template>
  <div class="footer-size"> 
      <footer class="new-footer" style="">
          <div class="md-layout md-gutter md-alignment-start-center">
              <div class="md-layout-item md-small-size-100">
                 <img alt="Logo Green Solutions" src="@/assets/LOGO-GREEN.png" width="200" />
                <div style="" class="rrss-links">
                  <a href="https://www.linkedin.com/company/greensolutions-gs/?trk=d_public_post_follow_view_profile" target="_blank" rel="noopener noreferrer"><img alt="Linkedin" src="@/assets/linkedin-in.svg"  style="padding: 10px"></a>
                  <a href="http://facebook.com/calculatuhuella" target="_blank"><img alt="Facebook" src="@/assets/facebook-f.svg"  style="padding: 10px"></a>
                  <a href="https://www.instagram.com/greensolutions.cl/" target="_blank"><img alt="Instagram" src="@/assets/instagram.svg"  style="padding: 10px; width: 54px;"></a>
                </div>
              </div>
              <div class="md-layout-item md-small-size-100 contacUs" >
                <div class="internal-layout" v-if="weAreInCl">
                  <h2>Contáctanos:</h2>
                  <h4>Horario de atención: 09:00  a  19:00 hrs</h4>
                  <h4 >Av. Italia 850, Providencia, Santiago-Chile</h4>
                  <h4>Email: <a @click="mailTo" style="color: #ffff;" href=""> contacto@greensolutions.cl </a></h4>
                  <a href="tel:+56232300966" data-rel="external" style="color: #ffff !important;">
                    <h4 >+56 2 3230 0966</h4>
                  </a>
                </div>
                <div class="internal-layout" v-else>
                  <h2>Contáctanos:</h2>
                  <h4>Horario de atención: 09:00  a  19:00 hrs</h4>
                  <h4 >Av. Italia 850, Providencia, Santiago-Chile</h4>
                  <h4>Email: <a @click="mailTo" style="color: #ffff;" href=""> contacto@greensolutions.com.ar </a></h4>
                  <a href="tel:0261 156029191" data-rel="external" style="color: #ffff !important;">
                    <h4 >0261 156029191</h4>
                  </a>
                </div>
              </div>
              <div class="md-layout-item md-small-size-100 link-to-form">
                <h2>¿Tienes dudas?</h2>
            
                <h4 class="mt-2"> 
                  <a href="/about">
                    <img alt="Formulario" src="@/assets/form.svg" width="25px" style="margin-right: 10px;" />
                    <span>Dejanos un mensaje</span>
                  </a>
                </h4>
              </div>
          </div>
          <div class="derechos-reservados">
            <p>   
              <router-link to="/politicas-de-privacidad" style="color: white">
                CHILE & AMËRICA LATINA
                GREEN SOLUTIONS® - TODOS HABLAN DE SUSTENTABILIDAD, NOSOTROS LA CERTIFICAMOS -TODOS LOS DERECHOS RESERVADOS © - 2015
              </router-link>
            </p> 
          </div>
          
      </footer>
  </div>
</template>

<script>
export default {
  data () {
    return {
      weAreInCl: true
    }
  },
  created () {
    if (window.location.origin === 'http://greensolutions.com.ar' || window.location.origin === 'https://greensolutions.com.ar'){
      this.weAreInCl = false
    }
  },
  methods: {
    mailTo() {
      window.location.href = this.weAreInCl === true ? "mailto:contacto@greensolutions.cl" : "mailto:contacto@greensolutions.com.ar"
      gtag('event', 'Click', {

        event_category: 'e-mail',

        event_label: 'e-mail',

        value: 0

      });
    },
    makeAcall() {

    }
  }
}
</script>

<style>

.derechos-reservados p {
  color: white; 
  font-size: 10px; 
  text-align:center;
}

.footer-size {
  background-color: #525151;
  color: #ffffff
}
.new-footer  {
  padding: 2vw;
}
.rrss-links {
  text-align: center; 
  margin-top: 2rem
}

h4 a {
  font-weight: bold;
  color: #ffffff !important;
}
.contacUs {
  text-align: justify;
}
.internal-layout {
  width: 80%;
  margin: auto;
}

.derechos-reservados {
  width: 80%;
  margin: auto;
  text-align: center;
  margin-top: 2rem;
}
</style>